export interface Learning {
  title:string,
  subTitle:string,
  description:string,
  youtubeUrl:string,
}

export const _Learnings:Learning[] = [
  {
    title: 'オンライン教理勉強会5月',
    subTitle: '「徳の積み方」沓脱委員(2025.5.29)',
    description: '',
    youtubeUrl: 'https://www.youtube.com/embed/d8zfdiI9knw?si=-iEM2zk8IUN5rzxF'
  },
  {
    title: 'オンライン教理勉強会4月',
    subTitle: '「成程の人とは？～魅力あるおたすけ人になるために～」漆原委員(2025.4.29)',
    description: '',
    youtubeUrl: 'https://www.youtube.com/embed/IDxvX53h3rY?si=coU-FR79Eij2pb2N'
  },
  {
    title: 'オンライン教理勉強会3月',
    subTitle: 'オンライン教理勉強会「おやさとふしん青年会ひのきしん隊の元一日」山脇委員(2025.3.29)',
    description: '',
    youtubeUrl: 'https://www.youtube.com/embed/nmrCd-l6Uik?si=avpQyUkFtKjh7w3C'
  },
  {
    title: 'おた活セミナー8月',
    subTitle: '「ホスピタル・クラウン」',
    description: '',
    youtubeUrl: 'https://www.youtube.com/embed/RkXCQD67Qvg?si=tllMQ_26nhYC3ZWZ'
  },
  {
    title: 'おた活セミナー7月',
    subTitle: '「大教会で開催されている月1のラジオ体操」（2023.7.22）',
    description: '',
    youtubeUrl: 'https://www.youtube.com/embed/lMnSYWF8mE4?si=r9X1pIsP8rDGj1CI'
  },
  {
    title: 'おた活セミナー6月',
    subTitle: '「ごみひらいから見えてきたこと」（2023.6.22）',
    description: '',
    youtubeUrl: 'https://www.youtube.com/embed/MMiU7UhKc1w'
  },
  {
    title: '第四回オンライン教祖勉強会',
    subTitle: '「教祖のご誕生と生い立ち」（2023.5.29）',
    description: '',
    youtubeUrl: 'https://www.youtube.com/embed/nDNGiE6uMrw'
  },
  {
    title: 'おた活セミナー5月',
    subTitle: '「子ども食堂を初めてー芝白金ケース」（2023.5.22）',
    description: '',
    youtubeUrl: 'https://www.youtube.com/embed/lxyKXhOi33U'
  },
  {
    title: '第三回オンライン教祖勉強会',
    subTitle: '「ご存命の教祖の一日」（2023.4.29）',
    description: '',
    youtubeUrl: 'https://www.youtube.com/embed/-pTawhfop0Q'
  },
  {
    title: '第二回オンライン教祖勉強会',
    subTitle: '「元の理からみる教祖のお立場」（2023.3.29）',
    description: '',
    youtubeUrl: 'https://www.youtube.com/embed/y3Rr6-chCmQ'
  }
]